export default __webpack_public_path__ + "static/media/Kenji_Icon.5a28497b.png";